// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderBlock__right___GJF1s,
.HeaderBlock__left___pHebn,
.HeaderBlock__center___cECtO {
    display: flex;
    grid-area: var(--header-grid-area);
    gap: var(--space-s);
    align-items: center;
    justify-content: var(--header-block-position);
}

.HeaderBlock__center___cECtO {
    --header-block-position: center;
    --header-grid-area: center;
}

.HeaderBlock__left___pHebn {
    --header-block-position: flex-start;
    --header-grid-area: left;
}

.HeaderBlock__right___GJF1s {
    --header-block-position: flex-end;
    --header-grid-area: right;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Header/HeaderBlocks/HeaderBlock.css"],"names":[],"mappings":"AAAA;;;IAGI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;AAC7B","sourcesContent":[".right,\n.left,\n.center {\n    display: flex;\n    grid-area: var(--header-grid-area);\n    gap: var(--space-s);\n    align-items: center;\n    justify-content: var(--header-block-position);\n}\n\n.center {\n    --header-block-position: center;\n    --header-grid-area: center;\n}\n\n.left {\n    --header-block-position: flex-start;\n    --header-grid-area: left;\n}\n\n.right {\n    --header-block-position: flex-end;\n    --header-grid-area: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"right": `HeaderBlock__right___GJF1s`,
	"left": `HeaderBlock__left___pHebn`,
	"center": `HeaderBlock__center___cECtO`
};
export default ___CSS_LOADER_EXPORT___;
